module.exports = __webpack_public_path__ + "static/media/white_logo@3x.eb2b63f0.png";